<div *ngIf="photo?.title&&!(editableTitle&&isEditing)" class="scout-point-photo-title">
    {{photo.title}}
</div>

<div #outerDiv class="busy-overlay-parent" [ngClass]="{'disabled':bProcessing}">
    
<div *ngIf="bProcessing" class="font-weight-bold busy-overlay">
    <i class="fa fa-spinner fa-spin"></i>&nbsp;Processing...
</div>

<div *ngIf="maximizeCamView&&(bInspectNewPhoto||bShowWebCamPending||bShowWebcamView)" class="muted-overlay">
    <div *ngIf="bShowWebCamPending" class="h-100 text-center d-flex flex-column justify-content-center" style="color:lightgray;">
        Initializing camera view...
    </div>
</div>

<form #photoForm="ngForm" class="scout-point-photo-form">

    <ng-container *ngIf="isEditing && selectedPhoto.value">
        <div  class="moving-overlay">
        </div>
        <div class="moving-panel">
            <div class="d-flex flex-column">
                <div class="pb-2" *ngIf="photo!=selectedPhoto.value">
                    <div class="h5">Move Destination</div>
                    <div class="d-flex flex-row">
                        <button *ngIf="editableTitle" class="btn btn-secondary upload-form-button" (click)="onMoveBefore()"><i class="fa fa-arrow-left"></i><br>Before</button>
                        <button class="btn btn-secondary upload-form-button" (click)="onMoveReplace()" title="Move here"><i class="fa fa-bullseye"></i><br>Replace</button>
                        <button *ngIf="photoUrl" class="btn btn-secondary upload-form-button" (click)="onMoveSwap()"><i class="fa fa-arrows-alt-h"></i><br>Swap</button>
                        <button *ngIf="editableTitle" class="btn btn-secondary upload-form-button" (click)="onMoveAfter()"><i class="fa fa-arrow-right"></i><br>After</button>
                    </div>
                    <div>
                        <input type="checkbox" class="btn btn-secondary upload-form-button" [checked]="bIncludeTextInMove" (change)="bIncludeTextInMove=!bIncludeTextInMove">
                        Include notes and title
                    </div>
                </div>
                <div>
                    <button class="btn btn-warning upload-form-button" (click)="selectedPhoto.next(null)">Cancel Move</button>
                </div>
            </div>
        </div>
    </ng-container>
    
    <div *ngIf="errorMsg" class="alert alert-danger m-0">
        {{errorMsg}}
    </div>   

    <div *ngIf="flashMsg" class="flash-msg alert alert-info m-0">
        {{flashMsg}}
    </div>   


    <canvas *ngIf="bAlteringPhoto" style="display: none;" #alterPhotoCanvas width="0" height="0" ></canvas>

    <input name="fileInput" [(ngModel)]="fileName" #fileInput type="file" hidden  accept="image/*" (change)="onFileInputChanged($event)">

    <div *ngIf="photo" class="p-sm-1 m-0">
        <table class="w-100 scout-point-photo-field-table table-striped table-condensed">                
            <tbody>
            <tr *ngIf="editableTitle&&isEditing">
                <td colspan="9" class="w-100">
                    <input name="title" type='text' class="w-100" placeholder="title (optional)"
                        [(ngModel)]="photo.title" #title="ngModel" 
                        [ngClass]="{ 'invalid-input': title.invalid && (title.dirty || title.touched)}" >
                </td>
            </tr>
            <tr *ngIf="photo.notes||isEditing">
                <!--th style="width: 5em;">Notes</th-->
                <td *ngIf="!isEditing" colspan="9" class="w-100">
                    {{photo.notes}}
                </td>
                <td *ngIf="isEditing&&editableDescription" colspan="9" class="w-100">
                    <textarea name="notes" type='text' class="w-100" rows="2" placeholder="notes (optional)"
                        [(ngModel)]="photo.notes" #notes="ngModel" 
                        [ngClass]="{ 'invalid-input': notes.invalid && (notes.dirty || notes.touched)}" >
                    </textarea>
                </td>
            </tr>
            </tbody>
        </table>
    </div>

    <div *ngIf="!readOnly&&!photoUrl&&!bShowWebcamView&&!locked" class="text-center" style="padding: 80px 40px;">                
        <div>
            <button class="btn btn-secondary upload-form-button" (click)="fileInput.removeAttribute('capture');fileInput.click()">
                <i class="fa fa-file"></i> Choose File
            </button>
            <button *ngIf="mobileOs; else webcamBtn" (click)="fileInput.setAttribute('capture','camera');fileInput.click()"
                class="btn btn-secondary upload-form-button" >
                <i class="fa fa-camera"></i> Camera
            </button>
            <ng-template #webcamBtn>
                <div *ngIf="photoService.updatingCompatibleCameras||photoService.compatibleCameras?.length" class="btn-group p-0 m-0" dropdown>
                    <button [disabled]="photoService.updatingCompatibleCameras" (click)="onShowWebcam()" class="btn btn-secondary upload-form-button" style="margin-right:3px;" >
                         <i class="fa fa-camera" [ngClass]="{'blink':photoService.updatingCompatibleCameras}"></i> Webcam
                    </button>
                    <ng-container *ngIf="photoService.compatibleCameras?.length>0">
                    <button class="btn btn-secondary upload-form-button" dropdownToggle>
                        <i class="fa fa-caret-down"></i>
                    </button>
                    <ul *dropdownMenu class="ps-1 dropdown-menu" role="menu">
                    <li *ngFor="let camera of photoService?.compatibleCameras; " role="menuitem">
                        <button class="btn btn-secondary upload-form-button" (click)="setDefaultCamera(camera)">
                            <i *ngIf="selectedCameraId==camera?.deviceId" class="pr-1 fa fa-check-circle text-success"></i>{{camera?.label}}
                        </button>
                    </li>
                    <li role="menuItem">
                       <button [disabled]="bRefreshingCameraList" class="btn btn-info upload-form-button" (click)="refreshCameraList($event)">
                           <i class="fa fa-redo-alt" [ngClass]="{'fa-spin':bRefreshingCameraList}"></i>&nbsp;Refresh Camera List
                       </button>
                    </li>
                    <li role="menuItem">
                        <label class="pl-1 form-input">
                            <input type="checkbox" name="fullScreenCameraMode" [(ngModel)]="maximizeCamView" (change)="onMaximizeCamViewModeChange($event)">&nbsp;Maximize View
                        </label>
                    </li>
                    </ul>
                    </ng-container>
               </div>                
            </ng-template>
            
            <button *ngIf="isEditing && !(photo.group=='measurement'||photo.group=='wide-angle')" 
                    class="btn btn-danger upload-form-button" (click)="onDelete()">Delete</button>
        </div>     
    </div>

    <ng-container *ngIf="downloadProgress?.bytesTransferred && !downloadProgress.bComplete">
        <div *ngIf="downloadProgress.percentComplete > 0;else downloadWithoutKnownSize" class="progress">
            <div class="progress-bar progress-bar-striped bg-success" role="progressbar" [style.width.%]="downloadProgress.percentComplete">
            </div>
        </div>
        <ng-template #downloadWithoutKnownSize>
            <div class="px-1">{{downloadProgress.msg}}</div>
        </ng-template>
    </ng-container>

    
    <div *ngIf="photoUrl; else webcamViewer" [ngClass]="{'inspect-new-photo':bInspectNewPhoto}">
        <div class="photo-url-content d-flex flex-column justify-content-center">
        <div class="progress" *ngIf="uploadState?.bProcessing">
            <div class="progress-bar progress-bar-striped bg-success" role="progressbar" [style.width.%]="uploadState.percentComplete">
            </div>
        </div>
        <img [src]="photoUrl" class="photo-image" 
            [ngClass]="{'photo-editing':isEditing,'editable-title':editableTitle}" 
            [attr.role]="photoClickHandler?'button':''" (click)="onPhotoClick()">
        </div>
        <ng-template #inspectNewPhotoFooter>
            <div class="photo-url-footer d-flex flex-row justify-content-end align-items-center pr-2">
                <div>
                <button class="btn btn-primary upload-form-button" 
                    (click)="autoAcceptNewPhotoSub?.unsubscribe();bInspectNewPhoto=false;photoUrl=null;onShowWebcam()">
                    <i class="fa fa-camera"></i>&nbsp;Retake
                </button>
                <button class="btn btn-primary upload-form-button" 
                    (click)="autoAcceptNewPhotoSub?.unsubscribe();bInspectNewPhoto=false">
                    <i class="fa fa-check"></i>&nbsp;OK ({{autoAcceptNewPhotoCountdown}})
                </button>
                </div>
            </div>
        </ng-template>
        <div *ngIf="!bInspectNewPhoto; else inspectNewPhotoFooter" class="photo-url-footer">        
        <div class="d-flex flex-row justify-content-between">
            <div *ngIf="!readOnly&&isEditing&&!photoFile" class="btn-group">
                <button class="btn btn-warning upload-form-button" (click)="onRemovePhotoFile()">
                    <i class="fa fa-times"></i>&nbsp;Remove Photo
                </button>
                <div dropdown class="btn-group">
                    <button title="Additional Photo Actions..." 
                            class="ml-0 px-3 btn btn-secondary dropdown-toggle upload-form-button" 
                            dropdownToggle aria-controls="dropdown-edit-photo-options">
                    </button>
                    <ul id="dropdown-edit-photo-options" *dropdownMenu class="p-2 dropdown-menu" role="menu">                      
                    <li role="menuitem" *ngIf="deleteEnabled&&photo.fileName&&!(photo.group=='measurement'||photo.group=='wide-angle')">
                        <button (click)="onDelete()" class="btn btn-danger btn-photo-action">
                            <i class="fa fa-times"></i>&nbsp;Delete Photo & Metadata
                        </button>
                    </li>
                    <li role="menuitem" *ngIf="photo.fileName&&photoUrl!=MISSING_PHOTO_URL">
                        <div class="d-flex flex-row">
                        <div class="mx-0 my-auto photo-action-text" style="min-width:3.5em;">Rotate</div>
                        <button (click)="onRotatePhotoUrl(270)" class="text-center btn btn-secondary btn-photo-action" title="-90 degrees">
                            <i class="fa fa-level-up-alt" style="transform: rotate(-90deg)"></i>
                        </button>
                        <button (click)="onRotatePhotoUrl(90)" class="text-center btn btn-secondary btn-photo-action"  title="90 degrees">
                            <i class="fa fa-level-down-alt" style="transform: rotate(-90deg)"></i>
                        </button>
                        </div>
                    </li>
                    <li role="menuitem" *ngIf="moveEnabled&&photo.fileName">
                        <button (click)="selectedPhoto.next(photo)" [disabled]="!photo._id||!photo.uploadDate||photoForm.dirty||selectedPhoto.value" class="btn btn-secondary btn-photo-action"
                            title="Select for edit or move">
                            <i class="fa fa-arrows-alt"></i>&nbsp;Move
                        </button>
                    </li>
                    <li role="menuitem" *ngIf="photo.fileName&&photoUrl!=MISSING_PHOTO_URL">
                        <div class="d-flex flex-row">
                        <button (click)="onSave()" [disabled]="photoForm.pristine||bSaving" class="btn btn-secondary btn-photo-action">
                            <i class="fa fa-save"></i>&nbsp;Save
                        </button>
                        <button (click)="onOverwrite()" class="btn btn-warning btn-photo-action" title="Force resend of photo to server">
                            <i class="fa fa-upload"></i>&nbsp;Overwrite
                        </button>
                        </div>
                    </li>
                    <li role="menuitem" *ngIf="photo.uploadDate&&isOnline()">
                        <button (click)="onReloadPhoto()" class="btn btn-secondary btn-photo-action">
                            <i class="fa fa-redo"></i>&nbsp;Reload
                        </button>
                    </li>
                    </ul>
                </div>
            </div>
            <div *ngIf="photo?.fileName" class="align-self-baseline pl-sm-1" style="font-size:12px;font-style:italic;">
                <i *ngIf="(photoDoc&&!photoDoc.uploadDate) && (!photoFile&&photoUrl!=MISSING_PHOTO_URL)" 
                    class="fa fa-upload" [ngClass]="uploadState?.bProcessing?'blink text-muted':(errorMsg?'text-danger':'text-warning')"
                    title="Not uploaded"></i> 
                {{photo.fileName}}
            </div>
        </div>
        <ng-container *ngIf="!readOnly && isEditing && photoFile">
            <div>
                <button class="btn btn-secondary upload-form-button" (click)="resetFile()">Reset</button>
                <button *ngIf="!maximizeCamView" class="btn btn-secondary upload-form-button" (click)="onShowWebcam(true)">
                    <i class="fa fa-camera"></i>&nbsp;Retake
                </button>
                <div class="btn-group">
                    <button class="btn btn-danger upload-form-button" type="submit" (click)="onSave()">Save</button>
                    <div dropdown class="btn-group">
                        <button title="Additional Photo Actions..." 
                                class="ml-0 px-3 btn btn-secondary dropdown-toggle upload-form-button" 
                                dropdownToggle aria-controls="dropdown-photo-file-options">
                        </button>
                        <ul id="dropdown-photo-file-options" *dropdownMenu class="p-2 dropdown-menu" role="menu">                      
                        <li role="menuitem">
                            <div class="d-flex flex-row">
                            <div class="m-auto photo-action-text">Rotate</div>
                            <button (click)="onRotatePhotoUrl(270)" class="text-center btn btn-secondary btn-photo-action" title="-90 degrees">
                                <i class="fa fa-level-up-alt" style="transform: rotate(-90deg)"></i>
                            </button>
                            <button (click)="onRotatePhotoUrl(90)" class="text-center btn btn-secondary btn-photo-action"  title="90 degrees">
                                <i class="fa fa-level-down-alt" style="transform: rotate(-90deg)"></i>
                            </button>
                            </div>
                        </li>
                        </ul>
                    </div>                        
                </div>
            </div>
        </ng-container>
        </div>
    </div>

    <ng-template #webcamViewer>
        <div *ngIf="bShowWebcamView">
            <div (window:resize)="onResize($event)" [ngClass]="{'webcam-viewport':maximizeCamView}">
                <div [ngClass]="maximizeCamView?'w-100 h-100 d-flex justify-content-center align-items-center':'m-0 p-0'">
                    <webcam 
                    [width]="webcamViewWidth" 
                    [height]="webcamViewHeight" 
                    [trigger]="webcamTrigger.asObservable()" 
                    [allowCameraSwitch]="false"            
                    [captureImageData]="true"
                    [videoOptions]="webcamVideoOptions"
                    [imageType]="webcamImageType"
                    [imageQuality]=".9"
                    (imageCapture)="onWebcamImageCreated($event)"
                    (cameraSwitched)="onWebcamSwitched($event)"
                    (initError)="onWebcamInitError($event)"
                ></webcam>
                </div>
            </div>
            <div [ngClass]="{'webcam-controls':maximizeCamView}">
                <div class="w-100 h-100 d-flex flex-row justify-content-end align-items-center pr-2">
                    <button class="btn btn-warning upload-form-button" (click)="onCancel()">Cancel</button>
                    <button class="btn btn-primary upload-form-button" (click)="webcamTrigger.next();">
                        <i class="fa fa-bullseye"></i>&nbsp;Take Photo
                    </button>
                </div>
            </div>
        </div>
    </ng-template>
</form>

</div>